import React from 'react';
import ReactToPrint from 'react-to-print';
import PhiKhacApi from "service/phiKhacApi";
import { getDate } from 'utils/formatDate';
import { formatNumber } from 'utils/currencyFormat';
class ComponentToPrint extends React.Component {
  renderTableData() {
    var data = this.props.data;
    var lstPhiKhac = this.props.lstPhiKhac;
    if (typeof lstPhiKhac != "undefined" && lstPhiKhac.length > 0) {
      return lstPhiKhac.map((item, i) => {

        return (
          <tr>
            <td
              style={{
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
                textAlign: "center",
              }}
            >
              {i + 1}
            </td>
            <td
              style={{
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              {getDate(data.UpdatedTime)}
            </td>
            <td
              style={{

                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              <p>{item.TenPhiKhac}</p>
            </td>
            <td
              style={{
                textAlign: "right",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              <p class="text-right1">{item.GiaTri}</p>
            </td>
            <td
              style={{
                textAlign: "right",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              {item.LoaiPhiKhacChon == 1 ? (<>
                <div class="center-wrapper"><p class="text-right1"> Tiền </p></div>
              </>) : (<>
                <div class="center-wrapper"><p class="text-right1"> % </p></div>
              </>)}
            </td>
            <td
              style={{
                textAlign: "right",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              {formatNumber(item.ThanhTien)}
              {/* {item.LoaiPhiKhacChon == 1 ? (<>
                <div class="center-wrapper"><p class="text-right1"> {formatNumber(Math.round(item.GiaTri, 0))} </p></div>
              </>) : (<>
                <div class="center-wrapper"><p class="text-right1"> {formatNumber(Math.round(item.GiaTri, 0) * data.Sotienvay / 100)} </p></div>
              </>)} */}
            </td>
          </tr>
        );
      });
    }
  }
  render() {
    var totalPhiKhac = this.props.totalPhiKhac;
    return (
      <div
        style={{
          padding: "10px",
          margin: "5px",
          backgroundColor: "#ffffff",
          fontSize: "14px",
          fontFamily: "tahoma",
          marginBottom: "50px",
          height: "fit-content", //fix lỗi giãn dòng khi in
        }}
        id="htmlPrint"
      >
        <div style={{ marginBottom: "-2px", textAlign: "center" }}>
          <b> Danh sách phí khác</b>
        </div>
        <div
          style={{
            width: "100%",
            borderTopWidth: 0.5,
            borderTopStyle: "solid",
            borderTopColor: "#000000",
          }}
        ></div>

        <table
          style={{
            width: "100%",
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#000",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <th
              style={{
                width: "10%",
                textAlign: "center",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              STT
            </th>
            <th
              style={{
                width: "15%",
                textAlign: "center",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              Thời gian
            </th>
            <th
              style={{
                width: "45%",
                textAlign: "center",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              Tên
            </th>
            <th
              style={{
                width: "10%",
                textAlign: "center",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              LS Phí
            </th>
            <th
              style={{
                width: "10%",
                textAlign: "center",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              Tính theo
            </th>
            <th
              style={{
                width: "15%",
                textAlign: "center",
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: "#000",
              }}
            >
              Tổng tiền<br />{formatNumber(totalPhiKhac)}
            </th>
          </thead>
          <tbody>{this.renderTableData()}</tbody>
        </table>
      </div >
    );
  }
}
class inDanhSachPhiKhac extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lstPhiKhac: [],
      totalPhiKhac: 0
    };
  }

  componentDidMount() {

    let {
      data
    } = this.props;

    PhiKhacApi.listTheoChoVay1(data.ChoVayId, data.TypePaid).then((response) => {
      let state = this.state;
      state.lstPhiKhac = response.data;
      if (response.data.length > 0) {
        var tongtien = 0;
        response.data.map((item, index) => {
          tongtien += item.ThanhTien
        });
        state.totalPhiKhac = tongtien;
        this.setState(state);
      }
    });
  }


  render() {
    let { data } = this.props;
    return (
      <div>
        <div style={{ display: 'none' }}>
          <ComponentToPrint
            data={data}
            lstPhiKhac={this.state.lstPhiKhac}
            totalPhiKhac={this.state.totalPhiKhac}
            ref={(el) => (this.componentRef = el)}
          /> </div>
        <ReactToPrint
          trigger={() => (
            <button
              type="button"
              className="btn btn-new-main btn-checknew disk-mobile"
            >
              <span className="btn-icon-left">
                <i className="mdi mdi-printer"></i>
              </span>
              In danh sách
            </button>
          )}
          content={() => this.componentRef}
          copyStyles={false}
        />

      </div>
    );
  }
}
export default inDanhSachPhiKhac;
